import { render, staticRenderFns } from "./toUpdateDel.vue?vue&type=template&id=c2da9e58&"
import script from "./toUpdateDel.vue?vue&type=script&lang=js&"
export * from "./toUpdateDel.vue?vue&type=script&lang=js&"
import style0 from "./toUpdateDel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports